
import Vue from 'vue';

export default Vue.extend({
	name: 'DialogContent',
	props: {
		closeDisabled: { type: Boolean, default: false },
		title: { type: String, default: '' },
		// A smaller second line under the title, qualifying it (e.g. the plan a team is on, under the team's name)
		subtitle: { type: String, default: '' },
		tabs: { type: Array, default: () => [] },
		contentStyles: { type: [String, Object], default: 'max-height: 75vh;' },
		contentWrapperClass: { type: [String, Object], default: null },
		actionsWrapperClass: { type: [String, Object], default: 'px-6 mb-2' },
		headerStyles: { type: Object, default: () => ({}) },
	},
	methods: {
		onCancel() {
			this.$emit('on-cancel');
		},
	},
	computed: {
		hasTabs () {
			return !!this.tabs?.length;
		},
		contentWrapperClassComputed() {
			if (this.contentWrapperClass) {
				return this.contentWrapperClass;
			} else if (!this.contentWrapperClass && this.$vuetify.breakpoint.xsOnly) {
				return 'px-3 pt-3 d-flex flex-column';
			} else {
				return 'px-6 pt-6 d-flex flex-column';
			}
		},
	},
});
